import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Paper, Box } from "@mui/material";
import "../../Cyclone/DisturbanceTrack/DisturbanceTrack.css";
import LightningFeltReportsList from "./LightningFeltReportsList";
import LightningDeathData from "../DataPanel/DeathData/lightningDeathData";

const TABS = [
  { id: "feltreport", label: "Felt Report" },
  { id: "deathdata", label: "Death Data" },
];

function Reports() {
  const [searchParams] = useSearchParams();
  const initialTab = TABS.some((tab) => tab.id === searchParams.get("tab"))
    ? searchParams.get("tab")
    : "feltreport";
  const [activeSection, setActiveSection] = useState(initialTab);

  return (
    <div style={{ marginBottom: "1rem" }}>
      <div className="section-buttons-container" style={{ border: "0px" }}>
        {TABS.map((tab) => (
          <button
            key={tab.id}
            className={`section-button ${activeSection === tab.id ? "active" : ""}`}
            onClick={() => setActiveSection(tab.id)}
          >
            {tab.label}
          </button>
        ))}
      </div>

      <Paper elevation={0} sx={{ border: "1px solid #e2e8f0", borderRadius: "12px", overflow: "hidden", fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif", mt: 2 }}>
        <Box sx={{ p: 3 }}>
          <div className="section-content-container">
            <div className={`section-container ${activeSection === "feltreport" ? "active-section" : "hidden-section"}`}>
              <LightningFeltReportsList />
            </div>
            <div className={`section-container ${activeSection === "deathdata" ? "active-section" : "hidden-section"}`}>
              <LightningDeathData />
            </div>
          </div>
        </Box>
      </Paper>
    </div>
  );
}

export default Reports;
